import CoreEvents from "../core/events/CoreEvents";
import existingRetailMessageTemplate from "./existingRetailMessageTemplate";
import PreAccountOpeningController from "./PreAccountOpeningController";

var preAccountOpeningController = function (
    $scope,
    $rootScope,
    $state,
    $timeout,
    $modal,
    $translate,
    eventBus,
    preAccountOpeningFactory,
    redirectService,
    $injector,
    $q
) {
    var vm = this;

    vm.isDataLoaded = false;
    vm.countryCodes = [];
    vm.stateCodes = [];
    vm.isRegistered = null;
    vm.loading = false;
    vm.serviceError = false;

    $scope.init = function () {
        var deferred = $q.defer();

        preAccountOpeningFactory.retrieveCountryCode.query({}).$promise.then(
            function (data) {
                if (data !== null) {
                    vm.countryCodes = data.filter((c) => c.code == "US" || c.code == "CA");
                }
                deferred.resolve();
            },
            function () {
                deferred.reject();
            }
        );
        preAccountOpeningFactory.retrieveStateCode.query({}).$promise.then(
            function (data) {
                if (data !== null) {
                    vm.stateCodes = data;
                }
                deferred.resolve();
            },
            function () {
                deferred.reject();
            }
        );
        return deferred.promise;
    };

    function onInitSuccess() {
        vm.isDataLoaded = true;
    }

    function onInitFailure() {
        vm.isDataLoaded = true;
        vm.serviceError = true;
    }

    vm.openExistingRetailMessageModal = function () {
        $modal.open({
            templateUrl: existingRetailMessageTemplate,
            controller: PreAccountOpeningController,
            controllerAs: "paoCtl",
            size: "md",
            windowClass: "modal-wrapper",
            backdrop: "static",
            keyboard: false
        });
    };

    vm.redirect = function () {
        $state.go("registerInfo");
    };

    $scope.createRetailParticipant = function (body) {
        var deferred = $q.defer();
        vm.loading = true;

        preAccountOpeningFactory.createRetailParticipant.query({ ...body }).$promise.then(
            function (resp) {
                vm.loading = false;
                // eslint-disable-next-line no-prototype-builtins
                if (!resp.hasOwnProperty("error")) {
                    vm.isRegistered = resp.registered;
                    ga_valid();
                } else {
                    vm.serviceError = true;
                    ga_invalid();
                }
                deferred.resolve();
            },
            function () {
                vm.loading = false;
                vm.serviceError = true;
                deferred.reject();
            }
        );

        return deferred.promise;
    };

    const ga_valid = () => eventBus.dispatch(CoreEvents.OPEN_ACCOUNT_VALID, this);
    const ga_invalid = () => eventBus.dispatch(CoreEvents.OPEN_ACCOUNT_INVALID, this);

    $scope.init().then(onInitSuccess, onInitFailure);
};

preAccountOpeningController.$inject = [
    "$scope",
    "$rootScope",
    "$state",
    "$timeout",
    "$modal",
    "$translate",
    "eventBus",
    "preAccountOpeningFactory",
    "redirectService",
    "$injector",
    "$q"
];
export default preAccountOpeningController;
